import React, {useCallback, useEffect, useLayoutEffect, useRef, useState} from 'react';
import * as Yup from 'yup';
import {toast} from 'react-toastify';
import {Link, useHistory} from 'react-router-dom';
import {Form} from '@unform/web';
import CryptoJS from 'crypto-js';

import BoxSocial from '../../components/Form/BoxSocial';
import CustomButton from '../../components/Form/Button';
import Input from '../../components/Form/Input';

import {login} from '../../services/Auth';

import {IconButton, InputAdornment} from "@material-ui/core";
import {
  Container,
  LogoWrapper,
  Subtitle,
  Card,
  Title,
  FormWrapper,
  DividerText,
  FooterLink,
  CopyrightWrapper,
} from "./styles";
import {MdOutlineLogin} from "react-icons/md";
import logo from "../../assets/img/logo.png";
import Copyright from "../../components/Copyright";
import {useTranslation} from "react-i18next";
import {Visibility, VisibilityOff} from "@material-ui/icons";

function SignIn(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [isRedirectMobile, setRedirectMobile] = useState(false);
  const formRef = useRef(null);
  const history = useHistory();
  const [isLoadingAutoLogin, setLoadingAutoLogin] = useState(false);

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const autoLogin = useCallback(() => {
    async function initAutoLogin() {
      let username = localStorage.getItem('username');
      let password = localStorage.getItem('password');

      if (username && password) {
        username = CryptoJS.AES.decrypt(username, process.env.REACT_APP_CRYPTO_SECRET_KEY);
        username = username.toString(CryptoJS.enc.Utf8);

        password = CryptoJS.AES.decrypt(password, process.env.REACT_APP_CRYPTO_SECRET_KEY);
        password = password.toString(CryptoJS.enc.Utf8);

        console.log('fazendo auto login: ');
        const response = await login({
          username,
          password,
        });

        if (response && response.status === 200) {
          localStorage.setItem('@name', username);
          localStorage.setItem('@user_token', response.data.token);

          const redirectUrl = localStorage.getItem('redirectUrl');
          if (redirectUrl) {
            localStorage.removeItem('redirectUrl')
            history.push(redirectUrl);
          } else {
            history.push('/dashboard');
          }
        }
      }
      setLoadingAutoLogin(true);
    }
    initAutoLogin();
  }, [history]);

  useLayoutEffect(autoLogin, []);

  useEffect(() => {
    const search = props.location.search;
    const params = new URLSearchParams(search);
    const isApp = params.get('isRedirectMobile') || (props.location.state && props.location.state.params && props.location.state.params.isRedirectMobile);
    if (isApp) {
      localStorage.clear();
    }
    setRedirectMobile(isApp);
  }, []);

  async function handleLogin(data) {
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      formRef.current.setErrors({});
      const schema = Yup.object().shape({
        email: Yup.string()
            .email(t('email_invalid'))
            .required(t('blank_email')),
        password: Yup.string().required(t('blank_password'))
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      const response = await login({
        username: data.email,
        password: data.password,
      });

      if (response && response.status === 200) {
        if (isRedirectMobile) {
          setLoading(false);
          window.ReactNativeWebView.postMessage('{"name": "'+data.email+'", "user_token" : "'+response.data.token+'"}');
          return;
        }
        localStorage.setItem('@name', data.email);
        localStorage.setItem('userKey', data.email);
        localStorage.setItem('@user_token', response.data.token);

        const username = CryptoJS.AES.encrypt(data.email, process.env.REACT_APP_CRYPTO_SECRET_KEY).toString();
        const password = CryptoJS.AES.encrypt(data.password, process.env.REACT_APP_CRYPTO_SECRET_KEY).toString();

        localStorage.setItem('username', username);
        localStorage.setItem('password',password);

        toast.success(t('login_success'));
        history.push('/dashboard');
      } else {
        toast.error(t('login_invalid'));
      }
      setLoading(false);
    } catch (err) {
      toast.error(t('login_invalid'));
      setLoading(false);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(async () => {
    if (localStorage.getItem('autoLogin')) {
      localStorage.removeItem('autoLogin');
      let data = null;
      try {
        data = await login({
          username: localStorage.getItem('username'),
          password: localStorage.getItem('socialId'),
        });
      } catch (err) {
      }

      if (data && data.status === 200) {
        localStorage.setItem('@user_token', data.data.token);
        toast.success(t('login_success'));
        history.push('/dashboard');
      } else if (data) {
        toast.error(t('login_invalid'));
      }
    }
  }, []);

  return (
      <>
        {isLoadingAutoLogin && (
          <Container>
            <LogoWrapper>
              <Link to={"/"}>
                <img
                    alt={"Logo GBinary"}
                    src={logo}
                />
              </Link>
            </LogoWrapper>

            <Subtitle>{t('login_title')}</Subtitle>

            <Card>
              <Title>{t('login_enter_account')}</Title>
              <FormWrapper>
                <Form ref={formRef} onSubmit={handleLogin}>
                  <div style={{ marginBottom: 20 }}>
                    <Input
                        className="text-white"
                        type="text"
                        name="email"
                        label={t('login_label_input_user_email')}
                    />
                  </div>

                  <div style={{ marginBottom: 24 }}>
                    <Input
                        name="password"
                        type={showPassword ? 'text' : 'password'}
                        label={t('login_label_input_user_password')}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              onMouseUp={handleMouseUpPassword}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff sx={{ color: 'white' }}/> : <Visibility sx={{ color: 'white' }}/>}
                            </IconButton>
                          </InputAdornment>,
                        }}
                    />
                  </div>

                  <CustomButton
                    startIcon={<MdOutlineLogin/>}
                    className="signin-submit"
                    loading={loading}
                    type="submit"
                  >
                    {t('login_btn')}
                  </CustomButton>

                  <DividerText>{t('login_label_login_google')}</DividerText>
                  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
                    <BoxSocial/>
                  </div>

                  <FooterLink>
                    {t('login_not_account')}{' '}
                    <Link
                      to={{
                        pathname: '/register',
                        state: {
                          params: {
                            isRedirectMobile: `${isRedirectMobile}`,
                          }
                        }
                      }}
                    >
                      {t('login_register')}
                    </Link>
                  </FooterLink>
                </Form>
              </FormWrapper>
            </Card>

            <CopyrightWrapper>
              <Copyright/>
            </CopyrightWrapper>
          </Container>
        )}
      </>
  );
}

export default SignIn;
